import { Component, computed, inject, input } from "@angular/core";
import { APP_CONFIG_TOKEN } from "@kno2/core/config";
import { OrganizationAuthOption, OrganizationAuthRequirements } from "@kno2/core/session/user-profile.model";
import { DialogBodyComponent, DialogFooterComponent, DialogService } from "@kno2/shared/dialog";

const isUsableSignIn = (option: OrganizationAuthOption): boolean => option.kind !== "saml" || !!option.connectionName;

@Component({
    selector: "kno2-org-switcher-sign-in-modal",
    imports: [DialogBodyComponent, DialogFooterComponent],
    templateUrl: "./org-switcher-sign-in-modal.component.html"
})
export class OrgSwitcherSignInModalComponent {
    private readonly dialogService = inject(DialogService);
    private readonly appConfig = inject(APP_CONFIG_TOKEN);

    public readonly organizationName = input.required<string>();
    public readonly options = input<OrganizationAuthOption[]>([]);
    public readonly passwordScope = input<OrganizationAuthRequirements["passwordScope"]>(null);

    protected readonly choices = computed(() =>
        this.options()
            .filter(isUsableSignIn)
            .map((option) => ({ option, ...this.describe(option) }))
    );

    protected signIn(option: OrganizationAuthOption): void {
        this.dialogService.close(option);
    }

    protected cancel(): void {
        this.dialogService.close();
    }

    private describe(option: OrganizationAuthOption): { label: string; hint: string; icon: string } {
        switch (option.kind) {
            case "password":
                return {
                    label: "Username and password",
                    hint:
                        this.passwordScope() === "NonUserRoles"
                            ? `ADMINS ONLY: Sign in with your ${this.appConfig.brandDisplayName} username and password`
                            : `Sign in with your ${this.appConfig.brandDisplayName} username and password`,
                    icon: "fa-key"
                };
            case "pcc":
                return { label: option.label || "PointClickCare", hint: "Sign in with your PointClickCare account", icon: "fa-plus-square" };
            default:
                return {
                    label: option.label || option.connectionName || "Single sign-on",
                    hint: `Sign in with your ${option.label || "SSO"} account`,
                    icon: "fa-shield"
                };
        }
    }
}
